"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiLabels = _interopRequireDefault(require("@tencent/spaui-labels"));

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _default = function _default(props) {
  var onOpen = props.onOpen,
      html = props.html,
      value = props.value,
      multiple = props.multiple,
      placeholder = props.placeholder,
      _props$data = props.data,
      data = _props$data === void 0 ? {} : _props$data,
      unClose = props.unClose,
      propsValueLabelField = props.valueLabelField,
      disabled = props.disabled,
      onChange = props.onChange,
      onClickValueArea = props.onClickValueArea,
      _props$valueAreaStyle = props.valueAreaStyle,
      valueAreaStyle = _props$valueAreaStyle === void 0 ? {} : _props$valueAreaStyle,
      _props$valueAreaClass = props.valueAreaClassName,
      valueAreaClassName = _props$valueAreaClass === void 0 ? '' : _props$valueAreaClass,
      _props$labelFieldName = props.labelFieldName,
      labelFieldName = _props$labelFieldName === void 0 ? '' : _props$labelFieldName,
      _props$classNameMap = props.classNameMap,
      classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap;

  var _getTheContentOfTheVa = (0, _index.getTheContentOfTheValueAreaComponent)(props, true),
      onClear = _getTheContentOfTheVa.onClear,
      arrowDom = _getTheContentOfTheVa.arrowDom,
      showClearIcon = _getTheContentOfTheVa.showClearIcon;

  var valueLabelField = typeof propsValueLabelField === 'undefined' ? [labelFieldName, 'mark', 'description'] : propsValueLabelField; // 获取文案

  var getLabel = function getLabel() {
    var theValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var valueData = data[theValue] || {};
    var haveLabel = typeof valueData[labelFieldName] !== 'undefined';
    var label = haveLabel ? valueData[labelFieldName] : '';
    var result = ''; // 选项数据结构为对象

    if (_typeof(valueData) === 'object' && haveLabel) {
      if (multiple) {
        // 多选就只是-分隔
        result = [];
        valueLabelField.forEach(function (fieldName) {
          if (typeof valueData[fieldName] !== 'undefined') {
            result.push(String(valueData[fieldName]));
          }
        });
        result = result.join('-');
      } else {
        if (!html) {
          result = [];
          valueLabelField.forEach(function (fieldName) {
            if (typeof valueData[fieldName] !== 'undefined') {
              result.push(String(valueData[fieldName]));
            }
          });
          result = result.join('-');
        } else {
          result = _react["default"].createElement("span", null, valueLabelField.map(function (fieldName, index) {
            if (typeof valueData[fieldName] !== 'undefined' && fieldName === labelFieldName) {
              return _react["default"].createElement("span", {
                key: index,
                dangerouslySetInnerHTML: {
                  __html: valueData[fieldName]
                }
              });
            } else if (typeof valueData[fieldName] !== 'undefined' && fieldName === 'mark') {
              return _react["default"].createElement("i", {
                key: index,
                dangerouslySetInnerHTML: {
                  __html: valueData[fieldName]
                }
              });
            } else if (typeof valueData[fieldName] !== 'undefined') {
              return _react["default"].createElement("span", {
                key: index,
                dangerouslySetInnerHTML: {
                  __html: valueData[fieldName]
                }
              });
            }
          }));
        }
      }
    } else {
      if (multiple) {
        result = label;
      } else {
        if (!html) {
          result = label;
        } else {
          result = _react["default"].createElement("span", {
            dangerouslySetInnerHTML: {
              __html: label
            }
          });
        }
      }
    }

    return result;
  }; // 标签回调


  var onLabelsChange = function onLabelsChange(event, labelsData) {
    var result = '';

    if (multiple) {
      result = [];
      labelsData.map(function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        result.push(item.value);
        return item;
      });
    } else {
      if (labelsData.length > 0) {
        result = labelsData[0].value;
      }
    }

    if ((0, _spauiUtils.isFunction)(onChange)) {
      onChange(event, result, true);
    }
  }; // 点击内容展示区域


  var onValueAreaClick = function onValueAreaClick(event) {
    var target = event.target || null;

    if ((0, _spauiUtils.isFunction)(onOpen)) {
      if (target) {
        // 点的不是labels的删除按钮才关闭
        if (target.parentNode.className.indexOf('icon del') < 0 || labelData.length < 2) {
          onOpen(event);
        }
      } else {
        onOpen(event);
      }
    }

    if ((0, _spauiUtils.isFunction)(onClickValueArea)) {
      onClickValueArea(event);
    }

    if ((0, _spauiUtils.isFunction)(unClose)) {
      unClose(event);
    }
  }; // 获取Labels的数据


  var getLabelsData = function getLabelsData() {
    var result = [],
        tempData = {};

    if (multiple) {
      if ((0, _spauiUtils.isArray)(value)) {
        value.map(function (item) {
          tempData = {}; // 这个是Label组件自己的字段

          tempData.label = getLabel(item);
          tempData.value = item;

          if (_typeof(data) === 'object' && data && data[item] && data[item].disabled) {
            tempData["delete"] = false;
          }

          result.push(tempData);
          return item;
        });
      } else {
        console.error('【spaui-select】multiple为true时，value需要为数组，目前value=' + value);
      }
    } else {
      tempData = {};
      tempData.label = getLabel(value);
      tempData.value = value;

      if (_typeof(data) === 'object' && data && data[value] && data[value].disabled) {
        tempData["delete"] = false;
      }

      result = [tempData];
    }

    return result;
  };

  var labelData = getLabelsData();
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(classNameMap.SelectValueHolderClassName, valueAreaClassName),
    onClick: onValueAreaClick,
    style: valueAreaStyle
  }, labelData.length > 0 ? _react["default"].createElement(_spauiLabels["default"], {
    data: labelData,
    onChange: onLabelsChange,
    onClear: onClear,
    isClear: showClearIcon,
    clear: showClearIcon,
    disabled: disabled
  }) : _react["default"].createElement("span", {
    className: "selection-single-text"
  }, placeholder), arrowDom);
};

exports["default"] = _default;